/**
 * Unregisters the offline service worker and deletes its Cache Storage
 * entries. Does not reload the page or force-refetch live assets — this
 * app autosaves in-progress edits, so yanking the page out from under the
 * user from inside the Settings dialog would be surprising. The caller
 * (Settings > General) tells the user to reload manually afterward.
 */
export async function clearOfflineCache(): Promise<void> {
  if (!("serviceWorker" in navigator) || !("caches" in window)) {
    throw new Error("Offline caching isn't supported in this browser.");
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));

  const keys = await caches.keys();
  await Promise.all(
    keys.filter((key) => key.startsWith("yaqat-")).map((key) => caches.delete(key))
  );
}
